import { createContext, useContext, useState, ReactNode } from "react";

type ViewMode = "admin" | "user";

interface ViewModeContextType {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  isViewingAsUser: boolean;
}

const ViewModeContext = createContext<ViewModeContextType>({
  viewMode: "admin",
  setViewMode: () => {},
  isViewingAsUser: false,
});

export const ViewModeProvider = ({ children }: { children: ReactNode }) => {
  const [viewMode, setViewMode] = useState<ViewMode>("admin");

  return (
    <ViewModeContext.Provider
      value={{
        viewMode,
        setViewMode,
        isViewingAsUser: viewMode === "user",
      }}
    >
      {children}
    </ViewModeContext.Provider>
  );
};

export const useViewMode = () => useContext(ViewModeContext);
